 function initRecommendedProductSlider() {
    const products = document.querySelectorAll('.side_cart_pro');
    const prevBtn = document.querySelector('.rp-prev');
    const nextBtn = document.querySelector('.rp-next');
    const navigation = document.querySelector('.rp-navigation');

    if (products.length === 0) return;

    let currentStartIndex = 0;
    const totalProducts = products.length;

    // Get number of visible products based on screen size
    function getVisibleCount() {
      if (window.innerWidth <= 480) return 2;
      if (window.innerWidth <= 768) return 2;
      return 3;
    }

    function getVisibleCount() {
      if (window.innerWidth <= 768) return 2;
      if (window.innerWidth <= 1024) return 3;
      return document.querySelector('.cart_page_rec_card') ? 4 : 3;
    }

    // Show/hide products based on current position
    function updateVisibleProducts() {
      const visibleCount = getVisibleCount();

      // Hide all products first
      products.forEach((product) => {
        product.classList.remove('cs-visible');
      });

      // Show current visible range
      for (let i = currentStartIndex; i < currentStartIndex + visibleCount && i < totalProducts; i++) {
        if (products[i]) {
          products[i].classList.add('cs-visible');
        }
      }

      updateNavigationButtons();
    }

    // Update arrow button states
    function updateNavigationButtons() {
      if (!prevBtn || !nextBtn) return;

      const visibleCount = getVisibleCount();

      // Disable prev if at start
      prevBtn.disabled = currentStartIndex <= 0;

      // Disable next if we can't move forward anymore
      nextBtn.disabled = currentStartIndex >= totalProducts - visibleCount;
      
      // Hide navigation if all products fit
      if (navigation) {
        if (totalProducts <= visibleCount) {
          navigation.classList.add('hidden');
        } else {
          navigation.classList.remove('hidden');
        }
      }
    }

    // Move to previous product
    function movePrevious() {
      if (currentStartIndex > 0) {
        currentStartIndex--;
        updateVisibleProducts();
      }
    }

    // Move to next product
    function moveNext() {
      const visibleCount = getVisibleCount();
      if (currentStartIndex < totalProducts - visibleCount) {
        currentStartIndex++;
        updateVisibleProducts();
      }
    }

    // Event listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        movePrevious();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        moveNext();
      });
    }

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        // Adjust current index if needed for new screen size
        const visibleCount = getVisibleCount();
        const maxStartIndex = Math.max(0, totalProducts - visibleCount);
        currentStartIndex = Math.min(currentStartIndex, maxStartIndex);
        updateVisibleProducts();
      }, 150);
    });

    // Initialize - show first set of products
    updateVisibleProducts();
  } 
    
    setTimeout(function () {
    document.querySelectorAll(".product-swiper").forEach(function (el) {
      new Swiper(el, {
        loop: true,
        navigation: {
          nextEl: el.querySelector(".swiper-button-next"),
          prevEl: el.querySelector(".swiper-button-prev"),
        },
        slidesPerView: 1,
        spaceBetween: 0,
      });
    });
    console.log("load again123");
    }, 2500);
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      console.log("clicked on the cart button");
      setTimeout(function () {
    initRecommendedProductSlider();
    
    }, 2500);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  console.log("Hello Duniya cart update using qty");

  setTimeout(function () {
    initRecommendedProductSlider();
    
    }, 2500);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    
    console.log("Hello Duniya cart update 156");
//       document.querySelectorAll('.f10_disable').forEach(button => {
//     button.disabled = true;
// });
// document.querySelectorAll('.f10_disable').forEach(button => {
//   button.disabled = true;
//   $('.f10_msg_before_cart').hide();
//   button.insertAdjacentHTML(
//     'afterend',
//     '<div class="f10-message"> 1 Qty is already in your cart </div>'
//   );
// });

    // Upsell Products Js code 
  
   
   setTimeout(function () {
  initRecommendedProductSlider();
  
    }, 2500);

  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Recommended products: slider, cart-page AJAX add, server-synced cards
(() => {
  if (window.__kpRec) return;
  window.__kpRec = true;

  const SLIDER = '.recommended-products';
  const BOX = '.rec_cart_page';           // cart page only
  const BTN = `${BOX} .simple-add-to-cart-btn`;
  const $ = (s, r = document) => r.querySelector(s);
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const SPIN = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><circle cx="12" cy="12" r="9" stroke-opacity=".3"/><path d="M21 12a9 9 0 0 0-9-9"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur=".7s" repeatCount="indefinite"/></path></svg>';

  /*  slider  */
  const pos = new WeakMap();
  const per = (box) =>
    innerWidth <= 768 ? 2 : innerWidth <= 1024 ? 3 : box.querySelector('.cart_page_rec_card') ? 4 : 3;

  function paint(box) {
    const cards = [...box.querySelectorAll('.side_cart_pro')];
    const n = per(box);
    const s = Math.min(pos.get(box) || 0, Math.max(0, cards.length - n));
    pos.set(box, s);
    cards.forEach((c, i) => c.classList.toggle('cs-visible', i >= s && i < s + n));
    const prev = $('.rp-prev', box), next = $('.rp-next', box);
    if (prev) prev.disabled = s <= 0;
    if (next) next.disabled = s >= cards.length - n;
    $('.rp-navigation', box)?.classList.toggle('hidden', cards.length <= n);
  }
  const paintAll = () => document.querySelectorAll(SLIDER).forEach(paint);
  window.initRecommendedProductSlider = paintAll; // old setTimeout calls keep working

  document.addEventListener('click', (e) => {
    const b = e.target.closest(`${SLIDER} .rp-prev, ${SLIDER} .rp-next`);
    if (!b) return;
    e.preventDefault();
    const box = b.closest(SLIDER), n = per(box);
    const max = Math.max(0, box.querySelectorAll('.side_cart_pro').length - n);
    const s = pos.get(box) || 0;
    pos.set(box, b.classList.contains('rp-next') ? Math.min(max, s + n) : Math.max(0, s - n));
    paint(box);
  });

  let rt, mt;
  addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(paintAll, 150); });
  new MutationObserver(() => { clearTimeout(mt); mt = setTimeout(paintAll, 50); })
    .observe(document.body, { childList: true, subtree: true });

  /*  cart page: sync with server  */
  const mainId = () => $('#main-cart-items')?.dataset.id;
  const footId = () => $('#main-cart-footer')?.dataset.id;
  const ids = () => [mainId(), footId()].filter(Boolean).join(',');
  const pidOf = (card) => card.querySelector('.simple-add-to-cart-btn')?.dataset.productId;
  const sigOf = (cart) => cart.items.map((i) => i.product_id).sort().join(',');

  let lastSig = null; // which products the cards were built for

  // update cart table, totals and heading from section html
  function render(sections) {
    Object.values(sections || {}).forEach((html) => {
      const doc = parse(html);
      ['.cart_head_count', '#main-cart-items .js-contents', '#main-cart-footer .js-contents'].forEach((sel) => {
        const live = $(sel), next = $(sel, doc);
        if (live && next) live.innerHTML = next.innerHTML;
      });
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'kpRec' } }));
  }

  // swap the recommendation block for the fresh one rendered by Liquid
  function swapRecs(doc) {
    const fresh = [...doc.querySelectorAll(BOX)];
    const live = [...document.querySelectorAll(BOX)];
    if (live.length) {
      live[0].before(...fresh);
      live.forEach((el) => el.remove());
    } else if (fresh.length) {
      const form = $('form#cart');
      if (form) form.after(...fresh);
    }
    dropSoldOut();
    paintAll();
  }

  function dropSoldOut() {
    document.querySelectorAll(`${BOX} .side_cart_pro`).forEach((card) => {
      if (card.querySelector('.price--sold-out')) card.remove();
    });
  }

  let token = 0;
  async function refreshAll() {
    const my = ++token;
    const s = ids(), key = mainId();
    if (!s) return;
    try {
      const [cart, secs] = await Promise.all([
        fetch('/cart.js', { cache: 'no-store' }).then((r) => r.json()),
        fetch(`/?sections=${s}&t=${Date.now()}`, { cache: 'no-store' }).then((r) => r.json()),
      ]);
      if (my !== token) return; // a newer refresh is running
      render(secs);
      swapRecs(parse(secs[key] || ''));
      lastSig = sigOf(cart);
      updateBubble(cart.item_count);
    } catch (e) { /* ignore */ }
  }

  // refresh only when the cart's products differ from what the cards were built for
  async function sync(force) {
    if (!$(BOX) && !$('#main-cart-items')) return;
    try {
      const cart = await fetch('/cart.js', { cache: 'no-store' }).then((r) => r.json());
      if (force || lastSig === null || sigOf(cart) !== lastSig) refreshAll();
    } catch (e) { /* ignore */ }
  }
  let st;
  const scheduleSync = (ms = 300) => { clearTimeout(st); st = setTimeout(() => sync(false), ms); };

  // theme's own cart changes (qty, remove, clear)
  const _fetch = window.fetch;
  window.fetch = function (...a) {
    const p = _fetch.apply(this, a);
    const url = String(a[0]?.url || a[0] || '');
    if (/\/cart\/(change|update|clear)/.test(url)) p.then(() => scheduleSync()).catch(() => {});
    return p;
  };
  // save for later / move to cart dispatch this event (ignore our own)
  document.addEventListener('cart:updated', (e) => { if (e.detail?.source !== 'kpRec') scheduleSync(); });

  // back / forward / returning to the tab
  const isBackNav = () => performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
  addEventListener('pageshow', (e) => sync(e.persisted || isBackNav()));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') sync(false);
  });

  function updateBubble(count) {
    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      bubble.style.display = count > 0 ? '' : 'none';
      const span = bubble.querySelector('span');
      if (span) span.textContent = count;
    });
  }

  /*  ajax add to cart  */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(BTN);
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.disabled || btn.dataset.busy) return;

    btn.dataset.busy = '1';
    const original = btn.innerHTML;
    const pid = String(btn.dataset.productId);
    btn.innerHTML = SPIN;
    let added = false;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
          sections: ids(),
          sections_url: location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description);
      render(data.sections);
      added = true;
    } catch (err) {
      btn.disabled = true; btn.style.opacity = '.4'; btn.style.pointerEvents = 'none'; // out of stock / limit
    }

    btn.innerHTML = original;
    delete btn.dataset.busy;

    if (added) {
      document.querySelectorAll(`${BOX} .side_cart_pro`).forEach((card) => {
        if (pidOf(card) === pid) card.remove();
      });
      paintAll();
      fetch('/cart.js', { cache: 'no-store' })
        .then((r) => r.json())
        .then((c) => { lastSig = sigOf(c); updateBubble(c.item_count); });
    }
  }, true);

  /*  init  */
  dropSoldOut();
  paintAll();
  fetch('/cart.js', { cache: 'no-store' })
    .then((r) => r.json())
    .then((c) => { lastSig = sigOf(c); if (isBackNav()) refreshAll(); })
    .catch(() => {});
})();